module.exports = __webpack_public_path__ + "static/media/upperPart.44d44dad.jpg";